import axioslib, { AxiosInstance, AxiosRequestConfig, AxiosError } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { AddressValidationResponse, ResponseStatus } from "@iloq/shared";
import { Logger } from "@iloq/shared";

export default class AddressValidationApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  validateAddress(
    zipCode: string,
    city: string,
    countryCode: string
  ): Promise<AddressValidationResponse> {
    const baseUrl = "/api/v1/addressvalidation/validate/";
    const options: AxiosRequestConfig = {
      method: "GET",
      // eslint-disable-next-line
      url: `${baseUrl}?zipCode=${zipCode}&city=${city}&countryCode=${countryCode}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("AddressValidationApi.validateAddress failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("AddressValidationApi.validateAddress result:", result);
        return result.data as any;
      });
  }

  async validateAddressAndGetCities(
    zipCode: string,
    countryCode: string,
    isDHL?: boolean,
    isPickup?: boolean,
    cityName?: string
  ): Promise<string[]> {
    const baseUrl = "/api/v1/addressvalidation/city/";

    const optionalParams = isDHL
      ? `&serviceProvider=DHL${isPickup ? "&type=pickup" : ""}` +
        `${cityName ? `&cityName=${cityName}` : ""}`
      : "";

    const options: AxiosRequestConfig = {
      method: "GET",
      url: `${baseUrl}?zipCode=${zipCode}&countryCode=${countryCode}${optionalParams}`,
    };

    try {
      const { data } = await this.axios(options);
      return data;
    } catch (error) {
      const err = error as AxiosError;

      if (err.response?.status === ResponseStatus.notFound) {
        Logger.debug("AddressValidationApi.validateAddressAndGetCities failed - not found:", error);
      } else {
        Logger.error("AddressValidationApi.validateAddressAndGetCities failed:", error);
      }
      throw error;
    }
  }
}
